export function appendUTMParams(url, medium, source, campaign) {
  const params = generateUTMParams(medium, source, campaign);

  try {
    const newUrl = new URL(url);
    var searchParams = newUrl.searchParams;
    Object.keys(params).forEach((key) => searchParams.set(key, params[key]));
    newUrl.search = searchParams.toString();
    return newUrl.toString();
  } catch (e) {
    return url;
  }
}

export function generateUTMParams(medium, source, campaign) {
  return {
    utm_medium: medium ? medium : 'social',
    utm_source: source ? source : 'campsite.bio',
    utm_campaign: campaign,
  };
}
